import '@assets/styles/pages/visit-record.scss';
import { ReactElement, useEffect, useMemo } from 'react';
import VisitRecordImage from '@assets/images/check-circle 1.png';
import { useNavigate } from 'react-router-dom';
import useSiteLeadStore from '@store/siteLeadStore';
import useStepperStore from '@store/stepperStore';
import { useSetMainHeader } from '@hooks/useSetMainHeader';
import { getCurrentQuarterNumber } from '@helper/utils';
import { VISIT_STATUS } from '@config/constant';
import { disposeSiteVisitRecordingPlayback } from '@services/siteVisitRecording/siteVisitRecordingEngine';
import { SiteVisitRecordingPostVisitStartButton } from '@components/siteLeads/siteVisitRecording/SiteVisitRecordingPostVisitStartButton';
import { useFinalizeVisitFormRecordingOnSuccessPage } from '@components/siteLeads/siteVisitRecording/useFinalizeVisitFormRecordingOnSuccessPage';

export const VisitRecord = (): ReactElement => {
	useSetMainHeader();
	const nav = useNavigate();
	const { clearSiteLeadPersistedState, siteDetails } = useSiteLeadStore();
	const { setCurrentStep } = useStepperStore();

	useFinalizeVisitFormRecordingOnSuccessPage();

	useEffect(() => {
		disposeSiteVisitRecordingPlayback();
	}, []);

	const currentYear = useMemo((): string => {
		return new Date().getFullYear().toString().slice(-2);
	}, []);
	const handleClick = (): void => {
		// Reset the shared stepper so re-entering the visit flow later (e.g. from a contractor's
		// "+" button) starts at step 0 instead of staying on this Visit Recorded step.
		setCurrentStep(0);
		clearSiteLeadPersistedState();
		nav('/');
	};
	return (
		<section className="visit-recorded-section">
			<div className="container">
				<div className="visit-recorded-wrapper">
					<picture>
						<img src={VisitRecordImage} alt="check circle" title="success visit" width="200" height="200" />
					</picture>
					<h1 className="title">
						Visit {siteDetails?.verification_status_c === VISIT_STATUS.VISITED_VERIFIED ? 'Verified' : 'Recorded'}
					</h1>
					<p className="text-center">
						Successfully recorded a visit for {siteDetails?.name} in {getCurrentQuarterNumber('Q')} FY{currentYear}
					</p>

					<div className="btn-wrapper">
						{/* <SiteVisitRecordingPostVisitStartButton /> */}
						<button type="button" className="btn btn-primary btn-medium" id="dashboard-btn" onClick={handleClick}>
							Go to Dashboard
						</button>
					</div>
				</div>
			</div>
		</section>
	);
};
